// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file tabgraph/v1/session.proto (package tabgraph.v1, syntax proto3)
/* eslint-disable */

// Package tabgraph.v1 defines the canonical data types and services for the
// tabgraph application.

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tabgraph/v1/session.proto.
 */
export const file_tabgraph_v1_session: GenFile = /*@__PURE__*/
  fileDesc("Chl0YWJncmFwaC92MS9zZXNzaW9uLnByb3RvEgt0YWJncmFwaC52MSKeAgoHU2Vzc2lvbhIKCgJpZBgBIAEoCRIPCgd1c2VyX2lkGAIgASgJEhEKCWRldmljZV9pZBgDIAEoCRIMCgRuYW1lGAQgASgJEhMKC2Rlc2NyaXB0aW9uGAUgASgJEi4KCnN0YXJ0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCGVuZGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghzYXZlZF9hdBgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKbm9kZV9jb3VudBgJIAEoBRISCgplZGdlX2NvdW50GAogASgFEgwKBHRhZ3MYCyADKAkisAEKDlNlc3Npb25TdW1tYXJ5EgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSLgoKc3RhcnRlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIc2F2ZWRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCm5vZGVfY291bnQYBSABKAUSEgoKZWRnZV9jb3VudBgGIAEoBUJHWkVnaXRodWIuY29tL3N0cmF0dXNzdHVkaW9zL3RhYmdyYXBoL2JhY2tlbmQvZ2VuL3RhYmdyYXBoL3YxO3RhYmdyYXBodjFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Session represents a named browsing session containing a captured graph.
 *
 * @generated from message tabgraph.v1.Session
 */
export type Session = Message<"tabgraph.v1.Session"> & {
  /**
   * id is the unique session identifier, prefixed ses_<ksuid>.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * user_id is the owning user's identifier.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * device_id identifies the device that originated this session.
   *
   * @generated from field: string device_id = 3;
   */
  deviceId: string;

  /**
   * name is the user-assigned session name; empty until the session is saved.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * description is an optional freeform description set by the user.
   *
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * started_at is when the extension began capturing this session.
   *
   * @generated from field: google.protobuf.Timestamp started_at = 6;
   */
  startedAt?: Timestamp | undefined;

  /**
   * ended_at is when the session was closed; unset while the session is active.
   *
   * @generated from field: google.protobuf.Timestamp ended_at = 7;
   */
  endedAt?: Timestamp | undefined;

  /**
   * saved_at is when the user explicitly saved the session; unset until saved.
   *
   * @generated from field: google.protobuf.Timestamp saved_at = 8;
   */
  savedAt?: Timestamp | undefined;

  /**
   * node_count is the current count of unique nodes (pages) in the session.
   *
   * @generated from field: int32 node_count = 9;
   */
  nodeCount: number;

  /**
   * edge_count is the current count of directed edges in the session.
   *
   * @generated from field: int32 edge_count = 10;
   */
  edgeCount: number;

  /**
   * tags are user-assigned labels for organising sessions.
   *
   * @generated from field: repeated string tags = 11;
   */
  tags: string[];
};

/**
 * Describes the message tabgraph.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_session, 0);

/**
 * SessionSummary is a lightweight projection of Session used in list responses.
 *
 * @generated from message tabgraph.v1.SessionSummary
 */
export type SessionSummary = Message<"tabgraph.v1.SessionSummary"> & {
  /**
   * id is the unique session identifier, prefixed ses_<ksuid>.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * name is the user-assigned session name.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * started_at is when the extension began capturing this session.
   *
   * @generated from field: google.protobuf.Timestamp started_at = 3;
   */
  startedAt?: Timestamp | undefined;

  /**
   * saved_at is when the user explicitly saved the session; unset until saved.
   *
   * @generated from field: google.protobuf.Timestamp saved_at = 4;
   */
  savedAt?: Timestamp | undefined;

  /**
   * node_count is the current count of unique nodes in the session.
   *
   * @generated from field: int32 node_count = 5;
   */
  nodeCount: number;

  /**
   * edge_count is the current count of directed edges in the session.
   *
   * @generated from field: int32 edge_count = 6;
   */
  edgeCount: number;
};

/**
 * Describes the message tabgraph.v1.SessionSummary.
 * Use `create(SessionSummarySchema)` to create a new message.
 */
export const SessionSummarySchema: GenMessage<SessionSummary> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_session, 1);

